import {Box, Text, ChakraProps, Input, InputGroup, InputRightElement, Select, Checkbox} from "@chakra-ui/react"
import {FC, useEffect, useState} from "react"
import {FaSearch, FaWindowClose} from "react-icons/fa"

/**
 * Filter.
 *
 * Represents default text input with
 * filter capabilities
 *
 * @param {specialLabel: string, updateFunc: Function}
 *
 */
export const Filter: FC<{
    specialLabel?: string,
    uniqueName: string,
    updateFunc: Function,
    reset?: boolean,
    type?: "input" | "select" | "checkbox",
    options?: any,
    height?: any,
    width?: any,
    placeholder?: any,
    style?: ChakraProps
}> = ({specialLabel, uniqueName, updateFunc, type, options, style, reset = false, height = "30px", width = "200px",placeholder=""}) => {
    const [val, setVal] = useState<string>("")
    const FilterDefaultStyleConfig: ChakraProps = {
        h: height,
        w: width,

        fontSize: "14px",
        color: "gray.700",
        paddingRight: "60px",
        _active: {
            borderColor: "gray.500"
        },
        _focus: {
            border: "2px solid",
            borderColor: "gray.500"
        },
        ...style
    }

    const update = (value: string) => {
        const x = {}
        //@ts-ignore
        x[uniqueName] = value
        setVal(value)
        updateFunc(x)
    }
    const handleKeyPress = (event: any) => {
        if (event.key === 'Enter') {
            setVal(event.target.value)
            update(event.target.value)
        }
    }
    useEffect(() => {
        if (reset) {
            update("")
        }
    }, [reset]);

    return (
        <Box maxW={width}>
            <Text fontSize="14px">{specialLabel}</Text>

            {type === "select"
                ? <Select {...FilterDefaultStyleConfig} pr="0px" value={val}
                          onChange={(ev: any) => update(ev.target.value)}>
                    {options}
                </Select>
                : type === "checkbox"
                    //@ts-ignore
                    ? <Box colorScheme="teal" styleConfig={{ flexDir: "row", display: "flex" }} onChange={(ev) => updateFunc(ev.target.value)}>
                        {options?.map((elem: any) => <Checkbox colorScheme={"teal"} key={elem.id} value={elem.id} children={elem.name} mr="10px" />)}
                    </Box>
                    :

                    <InputGroup>
                        <Input
                            {...FilterDefaultStyleConfig}
                            value={val}
                            placeholder={placeholder}
                            onChange={(ev: any) => setVal(ev.target.value)}
                            onKeyPress={handleKeyPress}
                        />
                        <InputRightElement h={height} cursor="pointer">
                            <FaSearch onClick={() => update(val)}/>
                        </InputRightElement>
                        {val.length > 0 && <InputRightElement right="25px" h={height} cursor="pointer">
                            <FaWindowClose onClick={() => update("")}/>
                        </InputRightElement>}
                    </InputGroup>
            }
        </Box>
    )
}

